var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inputs'),_c('fields'),_c('checkbox'),_c('radios'),_c('selects')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }